import { EntityContentLayoutBlueprint, EntityHeaderLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const isRdapArchitectureEntity = (entity: { kind: string }) =>
  [
    'tenant',
    'domain',
    'system',
    'component',
    'api',
    'resource',
    'template',
  ].includes(entity.kind.toLocaleLowerCase('en-US'));

export const entityHeaderExtension = EntityHeaderLayoutBlueprint.make({
  name: 'rdap',
  params: {
    filter: isRdapArchitectureEntity,
    loader: async () => (await import('./EntityHeaderLayout')).EntityHeaderLayout,
  },
});

export const entityOverviewLayoutExtension = EntityContentLayoutBlueprint.make({
  name: 'rdap-overview',
  params: {
    filter: isRdapArchitectureEntity,
    loader: async () => (await import('./EntityOverviewLayout')).EntityOverviewLayout,
  },
});
